import { render, staticRenderFns } from "./AppNavbarSecondary4.vue?vue&type=template&id=2cf88fe2"
import script from "./AppNavbarSecondary4.vue?vue&type=script&lang=ts"
export * from "./AppNavbarSecondary4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports